module.exports = __webpack_public_path__ + "img/happiness.2d56ad4f.svg";